/**
 * Search Autocomplete API Layer
 * Initializes the Tagalys SearchSuggestions SDK and bridges it to the
 * searchAutocomplete state via the shared event bus.
 */

class SearchAutoCompleteAPILayer {
  constructor () {
    this.eventBus = window.theme.tagalys.searchAutocomplete.eventBus

    onTagalysReady(() => {
      this.initializeTagalysSearchAutocomplete()

      this.eventBus.subscribe('searchAutoComplete:state:term:updated', (term) => {
        window.theme.tagalys.searchAutocomplete.SDK.helpers.updateQuery(term)
      })

      this.eventBus.subscribe('searchAutoComplete:state:term:submitted', (term) => {
        window.theme.tagalys.searchAutocomplete.SDK.helpers.updateQuery(term)
      })
    })
  }

  initializeTagalysSearchAutocomplete () {
    window.theme.tagalys.searchAutocomplete.SDK = Tagalys.APIConnector.SearchSuggestions.new({
      params: {
        sections: {
          products: { count: window.theme.resultsConfig.autoCompleteLimit },
          searches: { count: window.theme.resultsConfig.autoCompleteKeywordLimit },
        }
      },
      failover: this.initializeShopifySearchAutocomplete.bind(this),
      onSuccess: response => {
        if (response.redirect_url) {
          this.updateSearchInputAction(response.redirect_url)
        } else {
          const term = window.theme.tagalys.searchAutocomplete.stateLayer.term
          this.updateSearchInputAction('/search?q=' + encodeURIComponent(term))
        }

        this.eventBus.publish('searchAutoComplete:api:results:fetched', response)
      },
      onFailure: response => {
        console.error('Failed response:', response)
      }
    })

    this.initializePopularSearches()
  }

  updateSearchInputAction (action) {
    const searchInputs = document.querySelectorAll('form[role="search"]')
    searchInputs.forEach(input => {
      input.action = action
    })
  }

  initializePopularSearches () {
    window.theme.tagalys.searchAutocomplete.SDK.helpers.getPopularSearches(3).then(response => {
      this.eventBus.publish('searchAutoComplete:api:initial:fetched', response)
    })
  }

  initializeShopifySearchAutocomplete () {
    return Tagalys.APIConnector.ShopifySearchSuggestions.new({
      params: {
        sections: {
          products: { count: window.theme.resultsConfig.autoCompleteLimit },
          searches: { count: window.theme.resultsConfig.autoCompleteKeywordLimit },
        },
      },
      onSuccess: response => {
        this.eventBus.publish('searchAutoComplete:api:results:fetched', response)
      },
      onFailure: response => {
        console.error('Failed response:', response)
      }
    })
  }
}

window.theme.tagalys.searchAutocomplete.apiLayer = new SearchAutoCompleteAPILayer()
